import { t } from '../helpers/i18n';

const SPOS_CONTRACT_STATUS: {
  [key: string]: { value: number; name: string };
} = {
  WAITING_TO_RECEIVE: {
    value: 0,
    name: t('SposContract.WaitingToReceive'),
  },
  APPRAISING: {
    value: 1,
    name: t('SposContract.Appraising'),
  },
  WAITING_FOR_APPROVE: {
    value: 2,
    name: t('SposContract.WaitingForApprove'),
  },
  ADD_PROFILE: {
    value: 3,
    name: t('SposContract.AddProfile'),
  },
  WAITING_FOR_CONFIG_DEVICE: {
    value: 4,
    name: t('SposContract.WaitingForConfigDevice'),
  },
  WAITING_FOR_ADD_DEVICE: {
    value: 10,
    name: t('SposContract.WaitingForAddDevice'),
  },
  APPRAISAL_APPROVED_WAITING_FOR_IMPLEMENT: {
    value: 5,
    name: t('SposContract.AppraisalApprovedWaitingForImplement'),
  },
  SUCCESSFUL_PROFILE_IMPLEMENT: {
    value: 6,
    name: t('SposContract.SuccessfulProfileImplement'),
  },
  PROFILE_DEPLOYMENT_FAILED: {
    value: 7,
    name: t('SposContract.ProfileDeploymentFailed'),
  },
  CLOSE_REQUEST: {
    value: 8,
    name: t('SposContract.CloseRequest'),
  },
};

const SPOS_CONTRACT_STATUS_DISPLAY: {
  [key: string]: { value: number; name: string; color?: string };
} = {
  WAITING_TO_RECEIVE: {
    value: 0,
    name: t('SposContract.WaitingToReceive'),
  },
  WAITING_FOR_APPRAISE: {
    value: -1,
    name: t('SposContract.WaitingForAppraise'),
    color: '#FF9900',
  },
  ADD_PROFILE: {
    value: 3,
    name: t('SposContract.AddProfile'),
    color: '#CC66FF',
  },
  WAITING_FOR_CONFIG_DEVICE: {
    value: 4,
    name: t('SposContract.WaitingForConfigDevice'),
    color: '#FF6666',
  },
  WAITING_FOR_ADD_DEVICE: {
    value: 10,
    name: t('SposContract.WaitingForAddDevice'),
    color: '#FF6666',
  },
  APPRAISAL_APPROVED_WAITING_FOR_IMPLEMENT: {
    value: 5,
    name: t('SposContract.AppraisalApprovedWaitingForImplement'),
    color: '#00CC00',
  },
  SUCCESSFUL_PROFILE_IMPLEMENT: {
    value: 6,
    name: t('SposContract.SuccessfulProfileImplement'),
    color: '#00CC00',
  },
  PROFILE_DEPLOYMENT_FAILED: {
    value: 7,
    name: t('SposContract.ProfileDeploymentFailed'),
    color: '#BEBEBE',
  },
  CLOSE_REQUEST: {
    value: 8,
    name: t('SposContract.CloseRequest'),
    color: '#BEBEBE',
  },
};

const UPDATE_SPOS_CONTRACT_STATUS: { [key: string]: any } = {
  CANCEL_CONTRACT: {
    label: t('UpdateSposContract.CancelContract'),
    value: 1,
  },
  AGREE_UPDATE_CONTRACT: {
    label: t('UpdateSposContract.AgreeUpdateContract'),
    value: 2,
  },
};

const SPOS_CONTRACT_TYPE: { [key: string]: any } = {
  NEW_MERCHANT: 1,
  NEW_SHOP: 2,
  NEW_TERMINAL: 3,
};

const EXPORT_CONTRACTS_STATUS = {
  FAILED: '403',
  PROCESSING: '402',
  SUCCESS: '000',
};

export default {
  SPOS_CONTRACT_STATUS,
  SPOS_CONTRACT_STATUS_DISPLAY,
  UPDATE_SPOS_CONTRACT_STATUS,
  SPOS_CONTRACT_TYPE,
  EXPORT_CONTRACTS_STATUS,
};
